<template>
    <el-breadcrumb class="breadcurmb" separator-class="el-icon-caret-right">
        <!-- <el-breadcrumb-item :to="{path:'/index'}"><i class="el-icon-s-fold"></i> 首页</el-breadcrumb-item> -->
        <el-breadcrumb-item><i class="el-icon-s-home"></i> 首页</el-breadcrumb-item>
        <el-breadcrumb-item v-for="list in currentPath" >{{list}}</el-breadcrumb-item>
    </el-breadcrumb>
</template>
<script>
    export default{
        data(){
            return {}
        },
        computed: {
            currentPath() {
                return this.$store.getters.breads;
            }
        }
    }
</script>
<style>
    .breadcurmb{
        line-height: 35px;
        padding-left: 15px;
        font-size: 15px;
        font-family: "Microsoft YaHei";
        letter-spacing: 2px;
        background-color: white;
        border-bottom:1px solid #F2F2F2;
        box-shadow: darkgrey 0px 2px 10px 0px;
    }
</style>
